import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
} from "@material-ui/core";
import {
  Toast,
  ConfirmationModal,
  SimpleToolbar,
  AddBusinessUnit,
  EditBusinessUnit,
  Loader,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { laboratoryServices, userServices, doctorServices } from "../services";
import { AuthContext } from "../context";
import { useDrawer } from "../hooks";
import {
  EditIconButton,
  EnableDisableIconButton,
  DeleteIconButton,
} from "../components/icon-buttons";
import handleDownloadExcel from "../helpers/download-excel";
export default function BusinessUnitsList(props) {
  const classes = useStyles();
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const { authState, signOut } = useContext(AuthContext);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [childLaboratories, setChildLaboratories] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [laboratoryIdToDelete, setLaboratoryIdToDelete] = useState(null);
  const [openEditLaboratoryModal, setOpenEditLaboratoryModal] = useState(false);
  const [laboratoryToEdit, setLaboratoryToEdit] = useState(null);
  const [openAddUserModal, setOpenUserModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [specialtiesList, setSpecialtiesList] = useState([]);
  const { isOpen, setIsOpen } = useDrawer();
  const [tableHeader, setTableHeader] = useState([]);
  const [tableBody, setTableBody] = useState([]);

  useEffect(() => {
    setTableHeader(["Nombre", "Usuario", "Correo", "Estado"]);

    const tableData = childLaboratories.map((childLab) => {
      return {
        Nombre: childLab.name || "",
        Usuario: childLab.user.username || "",
        Correo: childLab.user.email || "",
        Estado: childLab.user.status ? "Activo" : "Inactivo",
      };
    });
    setTableBody(tableData);
  }, [childLaboratories]);

  useEffect(() => {
    async function init() {
      try {
        const { status, response } = await doctorServices.getSpecialties();
        if (status === 200) {
          setSpecialtiesList(response.specialties);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        console.log(e);
      }
    }
    init();
  }, [signOut]);

  useEffect(() => {
    setReload(false);
    async function getChildLaboratories() {
      try {
        setLoading(true);
        const { status, response } =
          await laboratoryServices.getChildLaboratories({
            laboratoryId: authState.user.laboratory._id,
            page,
            limit,
            token: authState.token,
            text: "",
          });
        setLoading(false);
        if (status === 200) {
          setChildLaboratories(response.laboratories);
          setLimit(response.limit);
          setCount(response.total);
          setPage(response.page);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getChildLaboratories();
  }, [page, limit, reload, authState, signOut]);

  const getChildLaboratoriesFilter = async (text) => {
    try {
      setLoading(true);
      const { status, response } =
        await laboratoryServices.getChildLaboratories({
          laboratoryId: authState.user.laboratory._id,
          text,
          page,
          limit,
          token: authState.token,
        });
      setLoading(false);
      if (status === 200) {
        setChildLaboratories(response.laboratories);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const updateStatus = async (laboratory) => {
    try {
      setLoading(true);
      const { status: statusResp } = await userServices.updateUserStatus({
        _id: laboratory.user._id,
        status: !laboratory.user.status,
        token: authState.token,
      });
      setLoading(false);
      if (statusResp === 200) {
        setReload(true);
        setToast(true);
        setToastMessage("Laboratorio actualizado con exito");
      } else if (statusResp === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteLaboratory = async () => {
    try {
      setLoading(true);
      const { status, response } = await userServices.deleteUser({
        _id: laboratoryIdToDelete,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage(response.message);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToast(true);
        setToastMessage(response.error.message);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const confirmationModal = (_id) => {
    setOpenAlert(true);
    setLaboratoryIdToDelete(_id);
  };

  const handleClose = (value) => {
    setOpenEditLaboratoryModal(value);
    setLaboratoryToEdit(null);
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };
  const optionsToolbar = [
    {
      label: "Export excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Unidades de negocio",
          tableHeader: tableHeader,
          tableBody: tableBody,
        });
      },
    },
    {
      label: "Agregar",
      action: (e) => {
        setOpenUserModal(true);
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <ConfirmationModal
          open={openAlert}
          setOpenAlert={setOpenAlert}
          setConfirmAction={() => deleteLaboratory()}
        />
        <Toast
          message={toastMessage}
          open={toast}
          close={() => {
            setToast(false);
          }}
        />
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            {openEditLaboratoryModal && (
              <EditBusinessUnit
                laboratory={laboratoryToEdit}
                open={openEditLaboratoryModal}
                specialtiesList={specialtiesList}
                reload={() => setReload(true)}
                close={() => handleClose(false)}
                toast={(message, active) => handleToast(message, active)}
              />
            )}
            {openAddUserModal && (
              <AddBusinessUnit
                specialtiesList={specialtiesList}
                open={openAddUserModal}
                close={() => setOpenUserModal(false)}
                toast={(message, active) => handleToast(message, active)}
                reload={() => setReload(true)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                // addButton
                reload={() => setReload(true)}
                onFilter={(text) => getChildLaboratoriesFilter(text)}
                // table={"businessUnitTable"}
                // filename={"Unidades de negocio"}
                // onAdd={() => setOpenUserModal(true)}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                // tableHeader={tableHeader}
                // tableBody={tableBody}
                options={optionsToolbar}
              />
              <BaseTable tableId="businessUnitTable">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Usuario</StyledTableCell>
                    <StyledTableCell>Correo</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {childLaboratories.map((childLaboratory, index) => (
                    <StyledTableRow hover key={childLaboratory._id}>
                      <StyledTableCell>{childLaboratory.name}</StyledTableCell>
                      <StyledTableCell>
                        {childLaboratory.user.username}
                      </StyledTableCell>
                      <StyledTableCell>
                        {childLaboratory.user.email}
                      </StyledTableCell>
                      <StyledTableCell>
                        {childLaboratory.user.status ? "Activo" : "Inactivo"}
                      </StyledTableCell>
                      <StyledTableCell>
                        <EditIconButton
                          onClick={() => {
                            setOpenEditLaboratoryModal(true);
                            setLaboratoryToEdit(childLaboratory);
                          }}
                          tooltipTitle="Editar unidad de negocios"
                        />
                        <EnableDisableIconButton
                          status={childLaboratory.user.status}
                          tooltipTitleEnable="Activar usuario"
                          tooltipTitleDisable="Desactivar usuario"
                          onClick={() => updateStatus(childLaboratory)}
                        />
                        <DeleteIconButton
                          tooltipTitle="Borrar unidad de negocios"
                          onClick={() =>
                            confirmationModal(childLaboratory.user._id)
                          }
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => setLimit(e.target.value)}
                onChangePage={(e, page) => setPage(page + 1)}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}));
